module.exports = __webpack_public_path__ + "static/media/TownPlannerIcon.0261631e.svg";